// Google Analytics 4 helpers — eventos de negocio
export const trackWhatsAppClick = (location) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'whatsapp_click', { location });
  }
};

export const trackPedidoEnviado = (method) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'pedido_enviado', method ? { method } : {});
  }
};

export const trackJuegoClick = (juego) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'juego_click', juego ? { juego } : {});
  }
};
